import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPremium = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Credit_Card_Shield_Protected",
	"data-name": "Credit Card, Shield,Protected",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12751",
			"data-name": "Path 12751",
			d: "M0,0H24V24H0Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12752",
			"data-name": "Path 12752",
			d: "M3,8H21",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12753",
			"data-name": "Path 12753",
			d: "M7,12.91h4",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12754",
			"data-name": "Path 12754",
			d: "M11,17H5a2,2,0,0,1-2-2V6A2,2,0,0,1,5,4H19a2,2,0,0,1,2,2v5",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12755",
			"data-name": "Path 12755",
			d: "M18,21s3-1.44,3-3.6V14.88l-2.188-.787a2.39,2.39,0,0,0-1.626,0L15,14.88V17.4C15,19.56,18,21,18,21Z",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export default SvgPremium;
